<template>
  <div v-loading="loading" style="height: 100%">
    <div v-show="show">
      <div class="viewDiv">
        <div id="pic1Div" style="position: relative">
          <img
            src
            id="pic1"
            style="width: 100%; height: 100%; position: absolute"
          />
          <div
            id="heng1"
            style="
              height: 2px;
              width: 100%;
              background: red;
              position: absolute;
              top: 0px;
            "
          ></div>
          <div
            id="heng2"
            style="
              height: 2px;
              width: 100%;
              background: red;
              position: absolute;
              bottom: 0px;
            "
          ></div>
          <div
            id="shu1"
            style="
              width: 2px;
              height: 100%;
              background: green;
              position: absolute;
              left: 0px;
            "
          ></div>
          <div
            id="shu2"
            style="
              width: 2px;
              height: 100%;
              background: green;
              position: absolute;
              right: 0px;
            "
          ></div>
        </div>
      </div>
      <div class="viewDiv">
        <div id="pic2Div" style="position: relative">
          <img
            src
            id="pic2"
            style="width: 100%; height: 100%; position: absolute"
          />
          <div
            id="heng11"
            style="
              height: 2px;
              width: 100%;
              background: blue;
              position: absolute;
              top: 0px;
            "
          ></div>
          <div
            id="heng12"
            style="
              height: 2px;
              width: 100%;
              background: blue;
              position: absolute;
              bottom: 0px;
            "
          ></div>
          <div
            id="shu11"
            style="
              width: 2px;
              height: 100%;
              background: red;
              position: absolute;
              left: 0px;
            "
          ></div>
          <div
            id="shu12"
            style="
              width: 2px;
              height: 100%;
              background: red;
              position: absolute;
              right: 0px;
            "
          ></div>
        </div>
      </div>
      <div class="viewDiv">
        <div id="pic3Div" style="position: relative">
          <img
            src
            id="pic3"
            style="width: 100%; height: 100%; position: absolute"
          />
          <div
            id="heng21"
            style="
              height: 2px;
              width: 100%;
              background: blue;
              position: absolute;
              top: 0px;
            "
          ></div>
          <div
            id="heng22"
            style="
              height: 2px;
              width: 100%;
              background: blue;
              position: absolute;
              bottom: 0px;
            "
          ></div>
          <div
            id="shu21"
            style="
              width: 2px;
              height: 100%;
              background: green;
              position: absolute;
              left: 0px;
            "
          ></div>
          <div
            id="shu22"
            style="
              width: 2px;
              height: 100%;
              background: green;
              position: absolute;
              right: 0px;
            "
          ></div>
        </div>
      </div>
      <div style="clear: both"></div>
      <div style="width: 500px; float: left">
        <h3 style="margin-left: 20px">选取心脏区域</h3>
        <div
          id="slider-range"
          style="
            width: 400px;
            margin-top: 20px;
            margin-left: 20px;
            background-color: red;
          "
        ></div>
        <div
          id="slider-range2"
          style="
            width: 400px;
            margin-top: 20px;
            margin-left: 20px;
            background-color: green;
          "
        ></div>
        <div
          id="slider-range3"
          style="
            width: 400px;
            margin-top: 20px;
            margin-left: 20px;
            background-color: blue;
          "
        ></div>
      </div>
      <div style="width: 500px; float: left">
        <h3 style="margin-left: 20px">切片顺序</h3>
        <div
          id="slider-range4"
          style="width: 400px; margin-top: 20px; margin-left: 20px"
        ></div>
        <div
          id="slider-range5"
          style="width: 400px; margin-top: 20px; margin-left: 20px"
        ></div>
        <div
          id="slider-range6"
          style="width: 400px; margin-top: 20px; margin-left: 20px"
        ></div>
      </div>
      <el-button type="primary" style="margin-top: 100px" @click="submitBox()"
        >提交</el-button
      >
      <el-button type="primary" style="margin-top: 100px" @click="goback()"
        >返回</el-button
      >
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";

export default {
  name: "Box",
  data() {
    return {
      loading: false,
      show: true,
      border: 400,
      pic1size: {},
      pic2size: {},
      pic3size: {},
      pic1show: { width: 0, height: 0 },
      pic2show: { width: 0, height: 0 },
      pic3show: { width: 0, height: 0 },
      url1: [],
      url2: [],
      url3: [],
    };
  },
  created() {},
  mounted() {
    this.initData();
  },
  methods: {
    async submitBox() {
      let shu1l = parseInt($("#shu1").css("left"));
      let shu2r = parseInt($("#shu2").css("right"));
      let x1 = parseInt((shu1l / this.pic1show.width) * this.pic1size.width);
      let x2 =
        parseInt((1 - shu2r / this.pic1show.width) * this.pic1size.width) - 1;

      let heng1t = parseInt($("#heng1").css("top"));
      let heng2b = parseInt($("#heng2").css("bottom"));
      let y1 = parseInt((heng1t / this.pic1show.height) * this.pic1size.height);
      let y2 =
        parseInt((1 - heng2b / this.pic1show.height) * this.pic1size.height) -
        1;

      let heng11t = parseInt($("#heng11").css("top"));
      let heng12b = parseInt($("#heng12").css("bottom"));
      let z1 = parseInt(
        (heng12b / this.pic2show.height) * this.pic2size.height
      );
      let z2 =
        parseInt((1 - heng11t / this.pic2show.height) * this.pic2size.height) -
        1;

      if (x1 >= x2 || y1 >= y2 || z1 >= z2) {
        this.$message({
          message: "box错误",
          type: "error",
        });
        return;
      }
      this.loading = true;
      const { data } = await this.$http.post(
        "/data/crop/" + this.$route.query.id,
        { x: [x1, x2], y: [y1, y2], z: [z1, z2] }
      );
      if (data.status === 100) {
        this.loading = false;
        this.$message({
          message: "完成裁剪",
          type: "success",
        });
        this.$router.push("/publishlist");
      }
    },
    async initData() {
      this.loading = true;
      this.show = false;
      const { data } = await this.$http.get(
        "/data/images/" + this.$route.query.id
      );
      if (data.status === 100) {
        this.loading = false;
        this.show = true;
        this.initPicture(data.data);
        this.initLine();
        this.initSlider();
      }
    },
    initPicture(data) {
      this.pic1size = { width: data.size1[0], height: data.size1[1] };
      this.pic2size = { width: data.size2[0], height: data.size2[1] };
      this.pic3size = { width: data.size3[0], height: data.size3[1] };
      this.url1 = data.view1;
      this.url2 = data.view2;
      this.url3 = data.view3;
      $("#pic1").attr("src", this.url1[this.url1.length / 2]);
      if (this.pic1size.width >= this.pic1size.height) {
        $("#pic1Div").css("width", this.border + "px");
        this.pic1show.width = this.border;
        let height = parseInt(
          (this.border / this.pic1size.width) * this.pic1size.height
        );
        $("#pic1Div").css("height", height + "px");
        this.pic1show.height = height;
        let top = parseInt((this.border - height) / 2);
        $("#pic1Div").css("top", top + "px");
      } else {
        this.pic1show.height = this.border;
        $("#pic1Div").css("height", this.border + "px");
        let width = parseInt(
          (this.border / this.pic1size.height) * this.pic1size.width
        );
        $("#pic1Div").css("width", width + "px");
        this.pic1show.width = width;
        let left = parseInt((this.border - width) / 2);
        $("#pic1Div").css("left", left + "px");
      }

      $("#pic2").attr("src", this.url2[this.url2.length / 2]);
      if (this.pic2size.width >= this.pic2size.height) {
        $("#pic2Div").css("width", this.border + "px");
        this.pic2show.width = this.border;
        let height = parseInt(
          (this.border / this.pic2size.width) * this.pic2size.height
        );
        $("#pic2Div").css("height", height + "px");
        this.pic2show.height = height;
        let top = parseInt((this.border - height) / 2);
        $("#pic2Div").css("top", top + "px");
      } else {
        this.pic2show.height = this.border;
        $("#pic2Div").css("height", this.border + "px");
        let width = parseInt(
          (this.border / this.pic2size.height) * this.pic2size.width
        );
        $("#pic2Div").css("width", width + "px");
        this.pic2show.width = width;
        let left = parseInt((this.border - width) / 2);
        $("#pic2Div").css("left", left + "px");
      }

      $("#pic3").attr("src", this.url3[this.url3.length / 2]);
      if (this.pic3size.width >= this.pic3size.height) {
        $("#pic3Div").css("width", this.border + "px");
        this.pic3show.width = this.border;
        let height = parseInt(
          (this.border / this.pic3size.width) * this.pic3size.height
        );
        $("#pic3Div").css("height", height + "px");
        this.pic3show.height = height;
        let top = parseInt((this.border - height) / 2);
        $("#pic3Div").css("top", top + "px");
      } else {
        this.pic3show.height = this.border;
        $("#pic3Div").css("height", this.border + "px");
        let width = parseInt(
          (this.border / this.pic3size.height) * this.pic3size.width
        );
        $("#pic3Div").css("width", width + "px");
        this.pic3show.width = width;
        let left = parseInt((this.border - width) / 2);
        $("#pic3Div").css("left", left + "px");
      }
    },
    initLine() {
      let left = 10;
      let right = 90;
      $("#heng1").css(
        "top",
        parseInt((left / 100) * this.pic1show.height) + "px"
      );
      $("#heng2").css(
        "bottom",
        parseInt((1 - right / 100) * this.pic1show.height) + "px"
      );
      $("#shu11").css(
        "left",
        parseInt((left / 100) * this.pic2show.width) + "px"
      );
      $("#shu12").css(
        "right",
        parseInt((1 - right / 100) * this.pic2show.width) + "px"
      );
      $("#shu1").css(
        "left",
        parseInt((left / 100) * this.pic1show.width) + "px"
      );
      $("#shu2").css(
        "right",
        parseInt((1 - right / 100) * this.pic1show.width) + "px"
      );
      $("#shu21").css(
        "left",
        parseInt((left / 100) * this.pic3show.width) + "px"
      );
      $("#shu22").css(
        "right",
        parseInt((1 - right / 100) * this.pic3show.width) + "px"
      );
      $("#heng11").css(
        "top",
        parseInt((left / 100) * this.pic2show.height) + "px"
      );
      $("#heng12").css(
        "bottom",
        parseInt((1 - right / 100) * this.pic2show.height) + "px"
      );
      $("#heng21").css(
        "top",
        parseInt((left / 100) * this.pic3show.height) + "px"
      );
      $("#heng22").css(
        "bottom",
        parseInt((1 - right / 100) * this.pic3show.height) + "px"
      );
    },
    initSlider() {
      let that = this;
      $("#slider-range").slider({
        range: true,
        min: 0,
        max: 100,
        values: [10, 90],
        slide: function (event, ui) {
          let left = ui.values[0];
          let right = ui.values[1];
          $("#heng1").css(
            "top",
            parseInt((left / 100) * that.pic1show.height) + "px"
          );
          $("#heng2").css(
            "bottom",
            parseInt((1 - right / 100) * that.pic1show.height) + "px"
          );
          $("#shu11").css(
            "left",
            parseInt((left / 100) * that.pic2show.width) + "px"
          );
          $("#shu12").css(
            "right",
            parseInt((1 - right / 100) * that.pic2show.width) + "px"
          );
        },
      });
      $("#slider-range2").slider({
        range: true,
        min: 0,
        max: 100,
        values: [10, 90],
        slide: function (event, ui) {
          let left = ui.values[0];
          let right = ui.values[1];
          $("#shu1").css(
            "left",
            parseInt((left / 100) * that.pic1show.width) + "px"
          );
          $("#shu2").css(
            "right",
            parseInt((1 - right / 100) * that.pic1show.width) + "px"
          );
          $("#shu21").css(
            "left",
            parseInt((left / 100) * that.pic3show.width) + "px"
          );
          $("#shu22").css(
            "right",
            parseInt((1 - right / 100) * that.pic3show.width) + "px"
          );
        },
      });

      $("#slider-range3").slider({
        range: true,
        min: 0,
        max: 100,
        values: [10, 90],
        slide: function (event, ui) {
          let left = ui.values[0];
          let right = ui.values[1];
          $("#heng11").css(
            "top",
            parseInt((left / 100) * that.pic2show.height) + "px"
          );
          $("#heng12").css(
            "bottom",
            parseInt((1 - right / 100) * that.pic2show.height) + "px"
          );
          $("#heng21").css(
            "top",
            parseInt((left / 100) * that.pic3show.height) + "px"
          );
          $("#heng22").css(
            "bottom",
            parseInt((1 - right / 100) * that.pic3show.height) + "px"
          );
        },
      });

      $("#slider-range4").slider({
        min: 0,
        value: that.url1.length / 2,
        max: that.url1.length - 1,
        slide: function (event, ui) {
          $("#pic1").attr("src", that.url1[ui.value]);
        },
      });
      $("#slider-range5").slider({
        min: 0,
        value: that.url2.length / 2,
        max: that.url2.length - 1,
        slide: function (event, ui) {
          $("#pic2").attr("src", that.url2[ui.value]);
        },
      });
      $("#slider-range6").slider({
        min: 0,
        value: that.url3.length / 2,
        max: that.url3.length - 1,
        slide: function (event, ui) {
          $("#pic3").attr("src", that.url3[ui.value]);
        },
      });
    },
    goback(){
      this.$router.go(-1);
    }
  },
};
</script>
<style lang="less" scoped>
.viewDiv {
  width: 400px;
  height: 400px;
  border: 1px solid black;
  float: left;
  margin-left: 5px;
  margin-top: 10px;
}
</style>
